import { ReactNode } from 'react';
import { ImageInterstitialType } from './components/SurveyItem/components/ImageInterstitial';
import { InfoImageInterstitialType } from './components/SurveyItem/components/InfoImageInterstitial';
import { QuestionType } from './components/SurveyItem/components/Question';
import { SectionDividerType } from './components/SurveyItem/components/SectionDivider';
import { AnswerModel, AnsweredQuestionsType } from './hooks';

export type OnItemViewedCB = (surveyItem: NextSurveyItemType) => void;

export type UseSetupCallbackCB = (questionId: string, answer: AnswerModel) => Promise<UserQuestionnaireType | null>;

export type SaveAnswerType = (submittedAnswer: string | object) => void;

export type SurveyItemType = QuestionType | ImageInterstitialType | SectionDividerType | InfoImageInterstitialType;

export type SectionType = {
  id: string;
  name: string;
  description: string;
  surveyItems: Array<SurveyItemType>;
};

export type NextSurveyItemType = {
  surveyItemId: string;
  sectionId: string;
};

export type QuestionnaireType = {
  version: number;
  type?: 'assessment' | 'screening';
  condition?: string;
  answerScreeningId?: string;
  sections: Array<SectionType>;
};

export enum QuestionnaireStatus {
  completed = 'COMPLETED',
  inaccurate = 'INACCURATE',
  uncompleted = 'UNCOMPLETED',
}

export type FollowUpType = {
  actions: string;
  descriptions: Array<string>;
};

export type QuestionnaireSummary = {
  date: 'string';
  body: Record<string, string>;
  header: Record<string, string>;
};

export type UserQuestionnaireType = {
  nextSurveyItem: NextSurveyItemType;
  nextIDontKnowAnsweredQuestion: NextSurveyItemType;
  answers: AnsweredQuestionsType;
  unclearAnswersFlow?: AnsweredQuestionsType;
  questionnaire: QuestionnaireType;
  status: QuestionnaireStatus;
  questionnaireStatistics?: {
    totalQuestionsCount: number;
    answeredQuestionsCount: number;
    iDontKnowAnswersCount: number;
    requiredQuestionsCount: number;
    answeredRequiredQuestionsCount: number;
  };
  isLastSurveyItem?: boolean;
  isLastIDKQuestion?: boolean;
  summary?: QuestionnaireSummary;
  result?: Array<FollowUpType>;
};

export type DecisionTreeProps = {
  userQuestionnaire: UserQuestionnaireType;
  callback: UseSetupCallbackCB;
  onItemViewed?: OnItemViewedCB;
  editQuestion?: NextSurveyItemType;
  backOnFirstSurveyItem?: () => void;
  isUnclearQuestionsFlow?: boolean;
  header?: (props: { onBackClick?: () => void; showBackButton?: boolean }) => ReactNode;
  passToStepBar?: boolean;
};

export type Steps = Array<{ id: string; name: string }>;
